;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import { LOCALES } from '@/i18nConfig';

export const locationsApiUrl = (locale: string): string => {
  switch (locale) {
    case LOCALES.EN_AU:
    case LOCALES.EN_NZ:
      return `${process.env.ATM_LOCATIONS_AU_API_URL}`;
    case LOCALES.EN_HK:
    case LOCALES.ZH_HK:
      return `${process.env.ATM_LOCATIONS_HK_API_URL}`;
    case LOCALES.EN_PL:
    case LOCALES.PL_PL:
      return `${process.env.ATM_LOCATIONS_PL_API_URL}`;
    default:
      return `${process.env.ATM_LOCATIONS_API_URL}`;
  }
};
